<!-- eslint-disable vue/no-v-html -->
<template>
	<MainContainer
		header-selected="contact-us"
		:loading="state.loading || pending"
		:fetched="!!data"
		:error="error"
		no-company-branding
		@try-again="refresh"
	>
		<div class="flex w-full flex-col px-4 pb-24 pt-16 lg:px-6">
			<div class="flex w-full max-w-screen-xl flex-col self-center">
				<div class="flex items-center">
					<span class="text-natural-dark flex-grow text-3xl font-black">
						{{ $t("contact_us") }}
					</span>
				</div>
				<div class="mt-16 flex flex-col">
					<div
						class="border-grey-200 bg-white mb-12 grid grid-cols-1 gap-6 rounded-lg border p-6 sm:grid-cols-2"
					>
						<div v-for="(item, i) in socialLinks" :key="i" class="flex flex-col">
							<div class="text-natural-dark mb-2 flex items-center">
								<Icon :name="item.icon" class="me-3 h-6 w-6" />
								<span class="text-sm">
									{{ item.title }}
								</span>
							</div>
							<a
								v-if="item.link"
								:href="item.link"
								class="text-natural-semidark self-start text-sm hover:text-primary"
								target="_blank"
							>
								<span dir="ltr">
									{{ item.value || "~" }}
								</span>
							</a>
							<span v-else class="text-natural-semidark self-start text-sm">
								{{ item.value || "~" }}
							</span>
						</div>
					</div>
					<div
						class="flex flex-col"
						v-html="data?.content || $t('edit_this_text_from_the_admin_panel')"
					></div>
				</div>
			</div>
		</div>
	</MainContainer>
</template>

<script lang="ts" setup>
const generalStore = useGeneralStore()
const metaStore = useMetaStore()
const route = useRoute()

const state = reactive({
	loading: false
})

const socialLinks = computed(() => generalStore.socialLinks)

const { data, error, pending, refresh } = useLazyAsyncData(String(route.path), async () => {
	const r = await metaStore.getAllMetas({
		names: [
			META_KEYS.META_CONTACT_US,
			META_KEYS.META_CONTACT_EMAIL,
			META_KEYS.META_CONTACT_ADDRESS,
			META_KEYS.META_SOCIAL_WHATSAPP,
			META_KEYS.META_SOCIAL_INSTAGRAM
		].join(",")
	})
	return {
		contact_email: r[META_KEYS.META_CONTACT_EMAIL],
		contact_address: r[META_KEYS.META_CONTACT_ADDRESS],
		social_whatsapp: r[META_KEYS.META_SOCIAL_WHATSAPP],
		social_instagram: r[META_KEYS.META_SOCIAL_INSTAGRAM],
		content: r[META_KEYS.META_CONTACT_US]
	}
})
</script>
